<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="6">
        <!-- Establecemos una referencia en el contenedor scrollable -->
        <v-row ref="scrollableRow" class="scrollable-row" no-gutters>
          <v-col
            cols="12"
            v-for="sample in samplesGuide"
            :key="sample.id"
            class="ma-2"
          >
            <SampleItemGuide :sample="sample" />
          </v-col>
        </v-row>
      </v-col>
      <v-col md="6">
        <v-form ref="form" lazy-validation>
          <v-row>
            <v-col>
              <v-card>
                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-text-field
                        :label="translations.origin_zip_code_label"
                        outlined
                        dense
                        clearable
                        type="text"
                        v-model="zipCode"
                        :rules="validation(translations.field_required)"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4">
                      <v-img
                        :src="require('../assets/img/caja_kit.png')"
                        :max-width="'200px'"
                      />
                    </v-col>
                    <v-col>
                      <v-row>
                        <v-col>
                          <span class="primary--text">{{
                            translations.label_total_samples
                          }}</span>
                          <span class="ml-2">{{ samplesGuide.length }}</span>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <span class="primary--text">{{
                            translations.kitType
                          }}</span>
                          <span class="ml-2">{{
                            translations.kitTypes[kitType]
                          }}</span>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-btn color="primary" @click="save()">
                            {{ translations.request_guide_label }}
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
    <SuccessGuideModal v-model="showSuccessGuideModal" @close="doneGuide" />
  </v-container>
</template>

<script>
import SampleItemGuide from "@/components/territory/SampleItemGuide.vue";
import SuccessGuideModal from "@/components/territory/modals/SuccessGuideModal.vue";
import { mapMutations, mapState, mapGetters, mapActions } from "vuex";
import { requiredValidation } from "@/helpers/validations.js";
export default {
  data() {
    return {
      // Definimos un tamaño máximo relativo a la altura de la ventana
      maxContainerHeightRatio: 0.8, // 80% de la pantalla
      showSuccessGuideModal: false,
      zipCode: null,
    };
  },
  mounted() {
    this.setContainerMaxHeight(); // Llamamos la función cuando el componente se monte
    window.addEventListener("resize", this.setContainerMaxHeight); // Escuchamos el cambio de tamaño de pantalla
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setContainerMaxHeight); // Eliminamos el listener al destruir
  },
  components: {
    SampleItemGuide,
    SuccessGuideModal,
  },
  created() {
    if (this.samplesGuide.length == 0) this.goBack();
    this.SET_APPBAR_OPTIONS({
      leftButton: "back-arrow",
      funcLeftButton: this.goBack,
    });
  },
  computed: {
    ...mapGetters("session", ["currentTranslations"]),
    translations() {
      return this.currentTranslations;
    },
    ...mapState("samples", ["samplesGuide", "kitType"]),
  },
  methods: {
    ...mapActions("agronomic", ["getCropCycle"]),
    ...mapActions("samples", ["requestSampleGuide"]),
    ...mapMutations(["SET_APPBAR_OPTIONS", "SET_LOADER"]),
    validation(name) {
      return requiredValidation(name);
    },
    goBack() {
      this.$router.back();
    },
    async save() {
      if (this.$refs.form.validate()) {
        try {
          let clientId = null;
          let user = JSON.parse(localStorage.getItem("user"));
          if (user.role == "ORG_USER" || user.role == "ORG_USER_ADMIN") {
            clientId = localStorage.getItem("organizationId");
          } else {
            clientId = localStorage.getItem("clientId");
          }
          this.SET_LOADER(true);
          let content = [];

          for (let sample of this.samplesGuide) {
            let cropName = "";
            let crop = await this.getCropCycle(sample.cropCycle);
            if (crop && crop.crop && crop.crop.cropName.length != 0) {
              cropName = crop.crop.cropName;
            }
            content.push({
              name: sample.soilArea.name,
              code: sample.container.code,
              crop: cropName,
              subSample: sample.subSamples.length,
              type: sample.sampleType,
              sampleType:
                sample.tracingStatus == "INITIAL" ? "Inicial" : "Seguimiento",
            });
          }
          let payload = {
            kits: this.samplesGuide.length,
            content: content,
            postalCode: this.zipCode,
            clientId: clientId,
            kitType: this.kitType,
          };
          console.log(payload);

          await this.requestSampleGuide(payload);
          this.showSuccessGuideModal = true;
        } catch (e) {
          console.log(e);
          this.SET_ALERT_TYPE({
            visible: true,
            type: "error",
            text: this.translations.advice_error,
            timeout: 4000,
          });
        }
        this.SET_LOADER(false);
      }
    },
    doneGuide() {
      this.showSuccessGuideModal = true;
      this.goBack();
    },
    setContainerMaxHeight() {
      if (this.$vuetify.breakpoint.smAndDown) {
        this.maxContainerHeightRatio = 0.5;
      } else {
        this.maxContainerHeightRatio = 0.8;
      }
      const screenHeight = window.innerHeight;
      const maxHeight = screenHeight * this.maxContainerHeightRatio;
      this.$refs.scrollableRow.style.maxHeight = `${maxHeight}px`;
      this.$refs.scrollableRow.style.overflowY = "auto"; // Activamos el scroll cuando sea necesario
    },
  },
};
</script>

<style>
.scrollable-row {
}
</style>
